import { get } from 'lodash';

const isSameLocation = (prevLocation, nextLocation) =>
  (prevLocation === nextLocation
    || get(nextLocation, 'state.originalLocation') === `${prevLocation.pathname}${prevLocation.search}`
  );

export const hasLocationChanged = (prevLocation, nextLocation) =>
  !isSameLocation(prevLocation, nextLocation);

const isSameLocationUrl = (prevLocationUrl, nextLocation) => {
  const nextLocationUrl = `${nextLocation.pathname}${nextLocation.search}`;

  return nextLocationUrl === prevLocationUrl
    || get(nextLocation, 'state.originalLocation') === prevLocationUrl;
};

export const hasLocationUrlChanged = (prevLocationUrl, nextLocation) =>
  !isSameLocationUrl(prevLocationUrl, nextLocation);
